/**
 * @version 1.0
 * @author xieyq
 * @createTime 2021/9/2
 * @updateTime 2021/9/2
 * @decription 申请复议-代理人相关处理js
 * @namespace 【dlr】
 */
import addDLR from '../addReconsider/addDLR/index.vue';
import {Dialog} from 'vant';
// 创建id
import {createId, customForEach} from "@/utils/common";
import {
    typeDlrlx
}
    from '@/filters/index';
export default {
    // 依赖组件
    components: {addDLR},
    // 数据
    data() {
        return {
            // 代理人数据列表
            dlrDataList: [],
            // 是否显示代理人弹层
            dlrShowPopup: false,
            // 正在编辑的代理人信息项
            dlrEditItem: null,
            // 正在编辑的代理人信息项索引
            dlrEditIndex: -1,
            // 代理人删除的id集合
            dlrDelIds: [],
            // 代理人是否加载完成
            dlrLoaded: false
        };
    },
    // 计算属性
    computed: {},
    // 监听
    watch: {},
    // 创建完成
    created() {
    },
    // 组件激活
    activated() {
    },
    // 组件初始化完成
    mounted() {
    },
    // 组件失去激活
    deactivated() {
    },
    // 销毁之前
    beforeDestroy() {
    },
    // 方法
    methods: {

        /**
         * 获取代理人数据
         * @returns {void}
         * */
        dlrGetData() {
            // 请求复议代理人数据
            this.requestFyDlr({
                // 复议id
                fyid: this.fyid,
                // 保全id
                bqid: this.bqid
            }).then(async (res) => {
                // 代理人数据列表
                const _dlrDataList = [];
                // 自定义forEach支持异步，原始的forEach不支持异步
                await customForEach(res.data, async item => {
                    // 如果保全id存在，则说明是从我的保全申请列表中跳转过来，这个是带过来的代理人列表，需要手动附上id和fyid
                    if (this.bqid) {
                        // cId 如果不存在则重新创建
                        if (!item.cId) {
                            item.cId = await createId();
                        }
                        // 复议id
                        item.cFyid = this.fyid;
                    }
                    // 转义代理人类型
                    item.cDlrlxText = typeDlrlx(item.cDlrlx);
                    _dlrDataList.push(item);
                })
                this.dlrDataList = _dlrDataList;
                // 代理人加载完成
                this.dlrLoaded = true;
                // 上传材料同步代理人数据
                this.bqid && this.scclSyncDlrData();
            })
        },

        /**
         * 添加、编辑代理人
         * @param {Object} item 代理人信息项数据
         * @param {Number} index 索引
         * @returns {void}
         * */
        dlrAddAEdit(item, index){
            if (item) {
                this.dlrEditItem = item;
                this.dlrEditIndex = index;
            }
            // 生成代理人表单
            this.dlrShowPopup = true;
        },

        /**
         * 删除代理人
         * @param {String} id 申请人id
         * @param {Number} index 当前申请人索引
         * @returns {void}
         * */
        dlrDelete(id, index) {
            Dialog.confirm({
                title: '提示',
                message: '删除代理人后，对应的代理人身份证明材料会一并删除，确认删除吗？',
                confirmButtonColor: '#ffffff',
                cancelButtonColor: '#ffffff'
            }).then(() => {
                // 代理人删除信息项
                this.dlrDeleteItem(id, index);
            })
                .catch((e) => {
                    console.log(e);
                });
        },

        /**
         * 代理人删除信息项
         * @param {String} id 申请人id
         * @param {Number} index 当前申请人索引
         * @returns {void}
         * */
        dlrDeleteItem(id, index) {
            // 根据人员id进行对应的身份证明材料的删除
            this.scclDelByRyId(this.dlrDataList[index].cId);
            // 删除对应的代理人数据
            this.dlrDataList.splice(index, 1);
            // 保存代理人删除的id
            this.dlrDelIds.push(id);
        },

        /**
         * 根据申请人id删除对应的代理人相关信息
         * @param {String} sqrId 申请人id
         * @returns {void}
         * */
        dlrDeleteBySqrId(sqrId) {
            // 当前不存在代理人列表，则直接返回
            if (!this.dlrDataList.length) {
                return;
            }
            // 倒序排查方便删除
            for (let i = this.dlrDataList.length - 1; i >=0; i--) {
                // 信息项
                const _item = this.dlrDataList[i];
                // 索引
                const _index = _item.cBqfySqrids.indexOf(sqrId);
                if (_index > -1) {
                    _item.cBqfySqrids.splice(_index, 1);
                    // 如果长度为0，则进行代理人删除，否则进行申请人id删除
                    if (!_item.cBqfySqrids.length) {
                        // 删除对应的代理人信息项
                        this.dlrDeleteItem(_item.cId, i);
                    } else {
                        _item.cFySqrid = _item.cBqfySqrids.join(',');
                    }
                }
            }
        },

        /**
         * 取消添加、编辑代理人
         * @returns {void}
         * */
        dlrCancel() {
            // 编辑信息项置为null
            this.dlrEditItem = null;
            // 索引置为-1
            this.dlrEditIndex = -1;
            // 代理人弹层为false
            this.dlrShowPopup = false;
        },

        /**
         * 获取转化代理人数据
         * @param {Object} formData 表单数据
         * @returns {Object} 转化之后的数据
         * */
        dlrGetTransformData(formData) {
            const _transformData = {
                ...formData
            };
            return _transformData;
        },

        /**
         * 处理代理人确认操作
         * @param {Object} formData 表单数据
         * @returns {void}
         * */
        dlrHandlerConfirm(formData) {
            const _transformData = this.dlrGetTransformData(formData);
            // 如果编辑数据，则说明是编辑数据
            if (this.dlrEditItem && this.dlrEditIndex > -1) {
                // 进行数据替换
                this.dlrDataList.splice(this.dlrEditIndex, 1, _transformData);
            } else {
                // 添加数据
                this.dlrDataList.push(_transformData);
            }
            // 同步人员名称
            this.scclSyncDataByRyId(_transformData.cId, _transformData.cDlrxm + '-代理人');
        },

        /**
         * 添加、编辑代理人表单确认操作
         * @param {Object} formData 表单数据
         * @returns {void}
         * */
        dlrConfirm(formData) {
            // 确认处理操作
            this.dlrHandlerConfirm(formData);
            // 代理人取消为false
            this.dlrCancel();
        },

        /**
         * 添加并继续
         * @param {Object} formData 表单数据
         * @returns {void}
         * */
        dlrConfirmAContinue(formData) {
            // 确认处理操作
            this.dlrHandlerConfirm(formData);
        }
    }
};
